import { render } from "./SeoManageForm.vue?vue&type=template&id=382e7bdc"
import script from "./SeoManageForm.vue?vue&type=script&lang=js"
export * from "./SeoManageForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__